<template>
  <div>
    <main-header-nav
      :goBack="goBack"
      :title="'主材价格列表'"
      :content="'新建主材信息价'">
    </main-header-nav>
    <el-card style="width: 400px;margin: 30px auto;padding: 30px 10px 10px 10px;">
      <major-material-price-form
        :type="type"
        :form="addForm"
        :rules="rules"
      >
      </major-material-price-form>
    </el-card>
  </div>
</template>
<script>
import MajorMaterialPriceForm from './MajorMaterialPriceForm'
import MainHeaderNav from '../common/MainHeaderNav'
export default {
  name: 'AddMajorMaterialPrice',

  components: {
    MajorMaterialPriceForm, MainHeaderNav
  },

  data () {
    var self = this
    var validateMajorMaterial = (rule, value, callback) => {
      if (self.addForm.majorMaterial.id === undefined) {
        callback(new Error('主材不能为空'))
      } else {
        callback()
      }
    }

    var validateMajorMaterialRegion = (rule, value, callback) => {
      if (self.addForm.majorMaterialRegion.id === undefined) {
        callback(new Error('地区不能为空'))
      } else {
        callback()
      }
    }
    return {
      type: 'add',
      rules: {
        majorMaterialId: [{ validator: validateMajorMaterial, trigger: ['blur', 'change'] }],
        majorMaterialRegionId: [{ validator: validateMajorMaterialRegion, trigger: ['blur', 'change'] }],
        date: [{ required: true, message: '日期不能为空', trigger: ['blur', 'change'] }],
        price: [{ required: true, message: '含税信息价不能为空', trigger: 'blur' }],
        priceNoTax: [{ required: true, message: '除税信息价不能为空', trigger: 'blur' }]
      },
      addForm: {
        majorMaterial: {},
        majorMaterialRegion: {},
        date: null,
        price: '',
        priceNoTax: ''
      }
    }
  },

  methods: {
    goBack () {
      this.$router.replace('/major_material_prices/' + this.addForm.majorMaterial.id)
    }
  },

  mounted () {
    var _this = this
    this.getRequest('/major_materials/' + this.$route.params.id).then(resp => {
      if (resp && resp.code === 200) {
        _this.$data.addForm.majorMaterial = resp.result
      }
    })
  }
}
</script>
<style scoped>

</style>
